import { Injectable } from '@angular/core';
import { IBusiness, IPlatformContext, Platforms } from '@core/models';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetPlatform } from '@core/actions';
import { PlatformContextState } from '@core/state/platform-context.state';
import { BusinessState } from '@core/state/business.state';

/**
 * Models
 */
export namespace DashboardNS {
  export interface State {
    getPlatform: Platforms;
  }
}

/**
 * Defaults
 */
export const DASHBOARD_DEFAULTS: DashboardNS.State = {
  getPlatform: Platforms.Meta as Platforms
};

@State<DashboardNS.State>({
  name: 'DashboardState',
  defaults: DASHBOARD_DEFAULTS
})
@Injectable()
export class DashboardState {
  constructor() {}

  @Selector([PlatformContextState.EnabledPlatformContexts, BusinessState.SelectedBusiness])
  static getPlatform(
    { getPlatform }: DashboardNS.State,
    connectedPlatformContexts: IPlatformContext[],
    business: IBusiness
  ): Platforms {
    const platform = getPlatform;
    const platformCtx = connectedPlatformContexts.some((context) => context.source === platform);
    if (platformCtx) return platform;
    const availableAccounts = business?.connectedAdAccounts.filter((adAccount) =>
      connectedPlatformContexts.some((ptx) => ptx.source === adAccount.source)
    );

    if (!availableAccounts.length) {
      return Platforms.Unset;
    }

    return availableAccounts.at(0)?.source!;
  }

  @Action(SetPlatform)
  setPlatform({ patchState }: StateContext<DashboardNS.State>, { payload }: SetPlatform) {
    patchState({ getPlatform: payload });
  }

  @Selector([BusinessState.SelectedBusiness])
  static selectedBusinessActivePlatformCurrency({ getPlatform }: DashboardNS.State, selectedBusiness: IBusiness) {
    return selectedBusiness?.connectedAdAccounts?.find((o) => o.source == getPlatform)?.currency || '-';
  }

  @Selector([BusinessState.SelectedBusiness])
  static selectedBusinessActivePlatform({ getPlatform }: DashboardNS.State, selectedBusiness: IBusiness) {
    return selectedBusiness?.connectedAdAccounts?.find((o) => o.source == getPlatform);
  }
}
